import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Switch from "../Common/Switch";
import InputText from "../sectioninput/formelement/InputText";
import _ from "lodash";
import {
  collections,
  types,
  placesNumber,
  availability,
  yesOrNo,
  caracteristiqueInputs,
  equipmentsInputs,
  equipementSwitches,
  jetInputs,
  jetSwitches,
  saunaCaracteristiqueInputs,
  saunaEquipmentsInputs,
  saunaAccessorySwitches,
  saunaCollections,
  saunaInfrarouge,
  spaDeNageCollections,
  spaDeNageInputs,
} from "./productsData";
import { updateProduct } from "../../REDUX/actions/products";
import { openModal } from "../../REDUX/actions/confirmationModal";
import ProductSubmitButton from "./ProductSubmitButton";
import Uploader from "../Common/Uploader";

import Lists from "../Lists/Lists";
import { Accordion, Form } from "react-bootstrap";
import { productUrlRewrite } from "../../utils/utils";
import RelatedProducts from "./RelatedProducts";

const ProductForm = ({ productItem }) => {
  const dispatch = useDispatch();

  const [productInputs, setproductInputs] = useState(
    productItem
      ? {
          ..._.omit(productItem.attributes, [
            "locale",
            "colors",
            "pointfort",
            "versionImages",
            "relatedProducts",
            "cuveColors",
            "banner",
            "createdAt",
            "ficheTechnique",

            "updatedAt",
            "seo",
            "jetCard",
            "pointreassurance",
            "realisation",
            "jetList",
          ]),
          description2: productItem.attributes.description2 || "",
        }
      : {},
  );
  console.log(productInputs);
  const handleProductChange = (value, champs) => {
    setproductInputs({ ...productInputs, [champs]: value });
  };

  const [image, setimage] = useState(productItem?.attributes?.image?.data);
  const [image2, setimage2] = useState(productItem?.attributes?.image2?.data);
  const [image3, setimage3] = useState(productItem?.attributes?.image3?.data);
  const [image4, setimage4] = useState(productItem?.attributes?.image4?.data);
  const [image5, setimage5] = useState(productItem?.attributes?.image5?.data);
  const [image6, setimage6] = useState(productItem?.attributes?.image6?.data);
  const [image7, setimage7] = useState(productItem?.attributes?.image7?.data);
  const [image8, setimage8] = useState(productItem?.attributes?.image8?.data);
  const [previewImg, setpreviewImg] = useState(
    productItem?.attributes?.previewImg?.data,
  );
  const [technicalSheet, settechnicalSheet] = useState(
    productItem?.attributes?.ficheTechnique?.data,
  );
  const [relatedProducts, setrelatedProducts] = useState();

  const handleUpdateProduct = () => {
    dispatch(
      updateProduct(productItem.id, {
        ...productInputs,
        path: productUrlRewrite(
          productItem.id,
          productItem.attributes.banner?.data?.attributes?.title ||
            productInputs.name,
        ),
        // relatedProducts: relatedProducts,
        image: image?.id,
        image2: image2?.id,
        image3: image3?.id,
        image4: image4?.id,
        image5: image5?.id,
        image6: image6?.id,
        image7: image7?.id,
        image8: image8?.id,
        previewImg: previewImg?.id,
        // ficheTechnique: technicalSheet.id,
      }),
    );
  };
  useEffect(() => {
    setproductInputs(
      productItem
        ? {
            ..._.omit(productItem.attributes, [
              "locale",
              "colors",
              "pointfort",
              "versionImages",
              "relatedProducts",
              "cuveColors",
              "banner",
              "createdAt",
              "ficheTechnique",

              "updatedAt",
              "seo",
              "jetCard",
              "pointreassurance",
              "realisation",
              "jetList",
            ]),
            description2: productItem.attributes.description2 || "",
          }
        : {},
    );

    setimage(productItem?.attributes?.image?.data);
    setimage2(productItem?.attributes?.image2?.data);
    setimage3(productItem?.attributes?.image3?.data);
    setimage4(productItem?.attributes?.image4?.data);
    setimage5(productItem?.attributes?.image5?.data);
    setimage6(productItem?.attributes?.image6?.data);
    setimage7(productItem?.attributes?.image7?.data);
    setimage8(productItem?.attributes?.image8?.data);
    setpreviewImg(productItem?.attributes?.previewImg?.data);
    // eslint-disable-next-line
  }, [productItem?.attributes]);

  const handleImage = (imageSelected) => {
    setimage(imageSelected);
  };
  const handleImage2 = (imageSelected) => {
    setimage2(imageSelected);
  };
  const handleImage3 = (imageSelected) => {
    setimage3(imageSelected);
  };
  const handleImage4 = (imageSelected) => {
    setimage4(imageSelected);
  };
  const handleImage5 = (imageSelected) => {
    setimage5(imageSelected);
  };
  const handleImage6 = (imageSelected) => {
    setimage6(imageSelected);
  };
  const handleImage7 = (imageSelected) => {
    setimage7(imageSelected);
  };
  const handleImage8 = (imageSelected) => {
    setimage8(imageSelected);
  };
  const handlePreviewImg = (previewImgSelected) => {
    setpreviewImg(previewImgSelected);
  };

  const clearSection1 = () => {
    setimage(null);
    setimage2(null);
    handleProductChange("", "description");
    setTimeout(() => {
      dispatch(
        updateProduct(productItem.id, {
          ...productInputs,
          description: "",
          path: productUrlRewrite(
            productItem.id,
            productItem.attributes.banner?.data?.attributes?.title ||
              productInputs.name,
          ),
          image: null,
          image2: null,
          image3: image3?.id,
          image4: image4?.id,
          image5: image5?.id,
          image6: image6?.id,
          image7: image7?.id,
          image8: image8?.id,
          previewImg: previewImg?.id,
        }),
      );
    }, 100);
  };

  const clearSection2 = () => {
    setimage3(null);
    setTimeout(() => {
      dispatch(
        updateProduct(productItem.id, {
          ...productInputs,
          path: productUrlRewrite(
            productItem.id,
            productItem.attributes.banner?.data?.attributes?.title ||
              productInputs.name,
          ),
          image: image?.id,
          image2: image2?.id,
          image3: null,
          image4: image4?.id,
          image5: image5?.id,
          image6: image6?.id,
          image7: image7?.id,
          image8: image8?.id,
          previewImg: previewImg?.id,
        }),
      );
    }, 100);
  };

  const clearSection3 = () => {
    setimage4(null);
    setimage5(null);
    setTimeout(() => {
      dispatch(
        updateProduct(productItem.id, {
          ...productInputs,
          path: productUrlRewrite(
            productItem.id,
            productItem.attributes.banner?.data?.attributes?.title ||
              productInputs.name,
          ),
          image: image?.id,
          image2: image2?.id,
          image3: image3?.id,
          image4: null,
          image5: null,
          image6: image6?.id,
          image7: image7?.id,
          image8: image8?.id,
          previewImg: previewImg?.id,
        }),
      );
    }, 100);
  };

  const clearSection4 = () => {
    setimage6(null);
    handleProductChange("", "description2");
    setTimeout(() => {
      dispatch(
        updateProduct(productItem.id, {
          ...productInputs,
          description2: "",
          path: productUrlRewrite(
            productItem.id,
            productItem.attributes.banner?.data?.attributes?.title ||
              productInputs.name,
          ),
          image: image?.id,
          image2: image2?.id,
          image3: image3?.id,
          image4: image4?.id,
          image5: image5?.id,
          image6: null,
          image7: image7?.id,
          image8: image8?.id,
          previewImg: previewImg?.id,
        }),
      );
    }, 100);
  };

  const clearSection5 = () => {
    setimage7(null);
    setimage8(null);
    setTimeout(() => {
      dispatch(
        updateProduct(productItem.id, {
          ...productInputs,
          path: productUrlRewrite(
            productItem.id,
            productItem.attributes.banner?.data?.attributes?.title ||
              productInputs.name,
          ),
          image: image?.id,
          image2: image2?.id,
          image3: image3?.id,
          image4: image4?.id,
          image5: image5?.id,
          image6: image6?.id,
          image7: null,
          image8: null,
          previewImg: previewImg?.id,
        }),
      );
    }, 100);
  };

  const showModalSection1 = () =>
    dispatch(
      openModal({
        type: "delete",
        confirmButtonText: "Supprimer",
        cancelButton: true,
        message: "Êtes-vous sûr(e) de vouloir supprimer la Section 1 ?",
        callBack: clearSection1,
      }),
    );

  const showModalSection2 = () =>
    dispatch(
      openModal({
        type: "delete",
        confirmButtonText: "Supprimer",
        cancelButton: true,
        message: "Êtes-vous sûr(e) de vouloir supprimer la Section 2 ?",
        callBack: clearSection2,
      }),
    );

  const showModalSection3 = () =>
    dispatch(
      openModal({
        type: "delete",
        confirmButtonText: "Supprimer",
        cancelButton: true,
        message: "Êtes-vous sûr(e) de vouloir supprimer la Section 3 ?",
        callBack: clearSection3,
      }),
    );

  const showModalSection4 = () =>
    dispatch(
      openModal({
        type: "delete",
        confirmButtonText: "Supprimer",
        cancelButton: true,
        message: "Êtes-vous sûr(e) de vouloir supprimer la Section 4 ?",
        callBack: clearSection4,
      }),
    );

  const showModalSection5 = () =>
    dispatch(
      openModal({
        type: "delete",
        confirmButtonText: "Supprimer",
        cancelButton: true,
        message: "Êtes-vous sûr(e) de vouloir supprimer la Section 5 ?",
        callBack: clearSection5,
      }),
    );

  const itemStyle = "card-body noBorder mb-4 p-0 rounded-10";
  const headerStyle = "mb-0 f24 fw-normal text-orange";

  return (
    <Accordion className=" rounded-10 mt-4 ">
      <Accordion.Item className={itemStyle} eventKey="0">
        <Accordion.Header className="d-flex align-items-center">
          <h2 className={headerStyle}>Séction Générale</h2>
        </Accordion.Header>
        <Accordion.Body>
          {/* <InputText
            labelinput="Nom du produit"
            handleChange={handleProductChange}
            champs="name"
            value={productInputs.name}
          />
          {/* =================================== URL REWRITE ============================================ */}
          {/* <InputText
            labelinput="Url"
            handleChange={handleProductChange}
            champs="path"
            value={productUrlRewrite(
              productItem.id,
              productItem.attributes.banner?.data?.attributes?.title ||
                productInputs.name,
            )} */}

          {/* =================================== URL REWRITE ============================================ */}

          <div className="row align-items-center mb-3 mt-4">
            <div className="col-12 mb-2">
              <h5>Image de Prévisualisation</h5>
            </div>
            <div className="col-6 mx-auto">
              <Uploader
                handleImage={handlePreviewImg}
                image={previewImg}
                resolution={"Image de prévisualisation"}
              />
            </div>
          </div>

          {/* ========== NOUVELLE STRUCTURE POUR PAGE PROJET ========== */}
          <div className="row align-items-center mb-3 mt-4">
            <div className="col-12 mb-2 pt-4 d-flex justify-content-between align-items-center">
              <h5 className="text-center flex-grow-1">Section 1</h5>
              <button
                type="button"
                className="btn btn-sm btn-danger"
                onClick={showModalSection1}
              >
                <i className="bi bi-x-lg"></i> Supprimer
              </button>
            </div>

            <div className="col-6">
              <Uploader
                handleImage={handleImage}
                image={image}
                resolution={"Image 1 - Gauche"}
              />
            </div>
            <div className="col-6">
              <Uploader
                handleImage={handleImage2}
                image={image2}
                resolution={"Image 2 - Droite"}
              />
            </div>
          </div>
          <InputText
            labelinput="Description"
            textArea
            handleChange={handleProductChange}
            champs="description"
            value={productInputs.description}
          />
          <div className="row align-items-center mb-3 mt-4">
            <div className="col-12 mb-2 mx-auto pt-4 d-flex justify-content-between align-items-center">
              <h5 className="text-center flex-grow-1">Section 2</h5>
              <button
                type="button"
                className="btn btn-sm btn-danger"
                onClick={showModalSection2}
              >
                <i className="bi bi-x-lg"></i> Supprimer
              </button>
            </div>
            <div className="col-6 mx-auto">
              <Uploader
                handleImage={handleImage3}
                image={image3}
                title={"Image 3 - Grande Image"}
              />
            </div>
          </div>

          <div className="row align-items-center mb-3 mt-4">
            <div className="col-12 mb-2 pt-4 d-flex justify-content-between align-items-center">
              <h5 className="text-center flex-grow-1">Section 3</h5>
              <button
                type="button"
                className="btn btn-sm btn-danger"
                onClick={showModalSection3}
              >
                <i className="bi bi-x-lg"></i> Supprimer
              </button>
            </div>
            <div className="col-6">
              <Uploader
                handleImage={handleImage4}
                image={image4}
                resolution={"Image 4 - Gauche"}
              />
            </div>
            <div className="col-6">
              <Uploader
                handleImage={handleImage5}
                image={image5}
                resolution={"Image 5 - Droite"}
              />
            </div>
          </div>

          <div className="row align-items-center mb-3 mt-4">
            <div className="col-12 mb-2 pt-4 d-flex justify-content-between align-items-center">
              <h5 className="text-center flex-grow-1">Section 4</h5>
              <button
                type="button"
                className="btn btn-sm btn-danger"
                onClick={showModalSection4}
              >
                <i className="bi bi-x-lg"></i> Supprimer
              </button>
            </div>
            <div className="col-6">
              <Uploader
                handleImage={handleImage6}
                image={image6}
                resolution={"Image 6 - Split Screen"}
              />
            </div>
            <div className="col-6">
              <InputText
                textArea
                handleChange={handleProductChange}
                champs="description2"
                value={productInputs.description2}
              />
            </div>
          </div>

          <div className="row align-items-center mb-3 mt-4">
            <div className="col-12 mb-2 pt-4 d-flex justify-content-between align-items-center">
              <h5 className="text-center flex-grow-1">Section 5</h5>
              <button
                type="button"
                className="btn btn-sm btn-danger"
                onClick={showModalSection5}
              >
                <i className="bi bi-x-lg"></i> Supprimer
              </button>
            </div>
            <div className="col-6">
              <Uploader
                handleImage={handleImage7}
                image={image7}
                resolution={"Image 7 - Gauche"}
              />
            </div>
            <div className="col-6">
              <Uploader
                handleImage={handleImage8}
                image={image8}
                resolution={"Image 8 - Droite"}
              />
            </div>
          </div>
          {/* ========== FIN NOUVELLE STRUCTURE ========== */}

          <ProductSubmitButton
            handleUpdateProduct={handleUpdateProduct}
            productInputs={productInputs}
          />
        </Accordion.Body>
      </Accordion.Item>

      {/* <Accordion.Item className={itemStyle} eventKey="12">
        <Accordion.Header>
          <h2 className={headerStyle}>Séction Images Principales</h2>
        </Accordion.Header>
        <Accordion.Body>
          <div className="row align-items-center">
            <div className="col">
              <div className="row">
                {image && (
                  <div className="col-6">
                    <Uploader
                      handleImage={handleImage}
                      image={image}
                      resolution={"Image Produit 2D"}
                    />
                  </div>
                )}
                {image2 && (
                  <div className="col-6">
                    <Uploader
                      handleImage={handleImage2}
                      image={image2}
                      resolution={"Image Produit 3D"}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          <ProductSubmitButton
            handleUpdateProduct={handleUpdateProduct}
            productInputs={productInputs}
          />
        </Accordion.Body>
      </Accordion.Item> */}
      {/* <Accordion.Item className={itemStyle} eventKey="10">
        <Accordion.Header>
          <h2 className={headerStyle}>Section autre images du produit</h2>
        </Accordion.Header>
        <Accordion.Body>
          {productItem.attributes.versionImages.data && (
            <Lists
              listData={productItem.attributes.versionImages.data}
              fetchProduct={productItem.id}
              resolution="carré"
            />
          )}
        </Accordion.Body>
      </Accordion.Item> */}
    </Accordion>
  );
};

export default ProductForm;
